// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KeywordCloud_keyword-cloud__5tl-C {
  background: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 20px;
  margin: 30px 0;
}
@media only screen and (max-width: 900px) {
  .KeywordCloud_keyword-cloud__5tl-C {
    padding: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/UnitDetail/Components/KeywordCloud/KeywordCloud.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,yCAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;AACF;AACE;EAPF;IAQI,aAAA;EAEF;AACF","sourcesContent":[".keyword-cloud {\n  background: #fff;\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\n  border-radius: 10px;\n  padding: 20px;\n  margin: 30px 0;\n\n  @media only screen and (max-width: 900px) {\n    padding: 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"keyword-cloud": `KeywordCloud_keyword-cloud__5tl-C`
};
export default ___CSS_LOADER_EXPORT___;
